import { HTTP } from '../http-common';
import discovery from '../discovery';

export default {
	// Constantes
	//TIPO:1,
	// Funciones comunes
	checkVersionHeader: function (response) {
		var version = response.headers['x-service-version'];
		if (window.$vue.$store.state.humanway.serviceVersion != version) {
			window.$vue.$store.commit('humanway/setServiceVersion', version);
			//console.log("Service version:" + version);
		}
	},
	getCommonHeaders()
	{
		var headers = {};

		headers = {
      'authorization': 'Bearer ' + window.localStorage.getItem("vue-token"),
			'X-DEVICE-UUID': window.localStorage.getItem("humanway-device-uuid")
		};

		if (/MSIE|Trident/.test(window.navigator.userAgent)) {
				headers['Pragma'] = 'no-cache';
				headers['Cache-Control'] = 'no-cache, no-store';
		}

		return { headers: headers };
	},
	genericGet(service,cbok, cberr)
	{
		HTTP.get(discovery.humanway_service_url + service, this.getCommonHeaders())
			.then((response) => {
					//this.checkVersionHeader(response);
					if (cbok)
						cbok(response.data);
			}).catch(function (error) {
					if (cberr)
						cberr(error);
			});
	},
	genericPut (service,data,cbok, cberr)
	{
		HTTP.put(discovery.humanway_service_url + service, data, this.getCommonHeaders())
			.then((response) => {
					if (cbok)
						cbok(response.data);
			}).catch(function (error) {
					if (cberr)
						cberr(error);
			});
	},
	genericPost(service,data,cbok, cberr)
	{
		HTTP.post(discovery.humanway_service_url + service, data, this.getCommonHeaders())
			.then((response) => {
					if (cbok)
						cbok(response.data);
			}).catch(function (error) {
					if (cberr)
						cberr(error);
			});
	},
	genericDelete(service,cbok, cberr)
	{
		HTTP.delete(discovery.humanway_service_url + service, this.getCommonHeaders())
			.then((response) => {
					if (cbok)
						cbok(response.data);
			}).catch(function (error) {
					if (cberr)
						cberr(error);
			});
	},

	/////////////////////////////////////////////////////////////////
	//WIDGETS

	getWidgets (cbok, cberr)
	{
			this.genericGet('widget/list', cbok, cberr);
	},
	getWidgetData (id, context, cbok, cberr)
	{
			this.genericPost(`widget/${id}`, context, cbok, cberr);
	},

	/////////////////////////////////////////////////////////////////	
	// MODULES

	getUserByUsername (username, cbok, cberr) 
	{
		this.genericPost('user/by-username', username, cbok, cberr);
	},
	getModules (cbok, cberr)
	{
			this.genericGet('module/list', cbok, cberr);
	},
	getModuleData (id, context, cbok, cberr)
	{
			this.genericPost(`module/${id}`, context, cbok, cberr);
	},

	/////////////////////////////////////////////////////////////////	
	// USERS
   
	getUser (id, cbok, cberr)
	{
			this.genericGet(`user/${id}`, cbok, cberr);
	},
	existsUser (data, cbok, cberr) 
	{
		this.genericPost(`user/exists`, data, cbok, cberr);
	},
	resetUserPassword (id, cbok, cberr)
	{
		this.genericPut(`user/${id}/reset-password`, null, cbok, cberr);
	},
	storeUser (user, cbok, cberr)
	{
			this.genericPost('user/', user, cbok, cberr);
	},
	deleteUser (id, cbok, cberr)
	{
			this.genericDelete(`user/${id}`, cbok, cberr);
	},

	/////////////////////////////////////////////////////////////////	
	// CONFIGS
   
	getConfig (id, cbok, cberr)
	{
			this.genericGet(`config/${id}`, cbok, cberr);
	},
	existsConfig (data, cbok, cberr) {
		this.genericPost(`config/exists`, data, cbok, cberr);
	},
	storeConfig (config, cbok, cberr)
	{
			this.genericPost('config/', config, cbok, cberr);
	}, 
	deleteConfig (id, cbok, cberr)
	{
			this.genericDelete(`config/${id}`, cbok, cberr);
	},

	/////////////////////////////////////////////////////////////////	
	// ASSESSMENTS

	getAssessment(id, cbok, cberr) {
		this.genericGet(`assessment/${id}`, cbok, cberr);
	},
	storeAssessment(data, cbok, cberr) {
		this.genericPost('assessment/', data, cbok, cberr);
	},
	deleteAssessment(id, cbok, cberr) {
		this.genericDelete(`assessment/${id}`, cbok, cberr);
	},
	getSkills(cbok, cberr) {
		this.genericGet('assessment-skill/list', cbok, cberr);
	},
	

}
